import { useMapDispatch } from "../../../../../../stateManagement/hooks/useMapDispatch";
import { MapName } from "../../../../../../stateManagement/reducers/maps/actions";
import { store } from "../../../../../../stateManagement/store";

/**
 * Универсальный патч list-checkbox-фильтра.
 *
 * @param mapName    карта (WaysideLandLots, Roads…)
 * @param fieldName  encumbranceType | rightType
 * @param patch  часть состояния фильтра для изменения
 *  | { ignore: boolean }
    | { includeNull: boolean }
    | { searchValue: string }
    | { toggleValue: { id: number | string; checked: boolean } };
 * @param dispatchMap dispatch-хелпер из useMapDispatch
 */
export function patchFilterListCheckboxState(
    mapName: MapName,
    fieldName: string,
    patch: any,
    dispatchMap: ReturnType<typeof useMapDispatch>,
) {
    const lowerFirstMapName = mapName[0].toLowerCase() + mapName.slice(1) as MapName
    const currentFilterState = store.getState().maps[lowerFirstMapName].mapFiltersState[fieldName];
    let patchForSend: any = {}
    if (!currentFilterState) return;

    // строится patchForSend */
    const { isIgnored, includeNull, searchValue, toggleValue } = patch ?? {}
    if ('isIgnored' in patch) patchForSend = { isIgnored }
    if ('includeNull' in patch) {
        patchForSend = { isIgnored: false, includeNull }
    }
    if ('searchValue' in patch) patchForSend = { searchValue }
    if ('toggleValue' in patch) {
        const { value, checked } = toggleValue;
        const values = currentFilterState.values.map((v: any) =>
            v.value === value ? { ...v, checked } : v,
        );
        patchForSend = { isIgnored: false, values }
    }

    dispatchMap(mapName, 'patchMapFiltersState', { fieldName, patch: patchForSend });
}
